// Microsoft Office Online viewer. It previews Office documents (Word, Excel, PowerPoint) by having Microsoft's
// servers fetch a publicly reachable file URL, so the source must be reachable without the caller's auth headers
// (a SharePoint pre-authenticated URL for library files, or a short-lived SAS URL for transient Copilot uploads
// and for the copies the API parks of provider library items). Shared by LinkPreviewVirtual (library documents),
// CopilotFilePreview (uploaded documents) and LinkPreviewBrokered (provider documents) so the detection rules
// stay in one place.

const officeExtensions = [
  '.doc',
  '.docx',
  '.docm',
  '.dot',
  '.dotx',
  '.xls',
  '.xlsx',
  '.xlsm',
  '.xlsb',
  '.ppt',
  '.pptx',
  '.pptm',
  '.pps',
  '.ppsx',
];

/**
 * Whether the viewer is the way to show this file. The MIME type decides when the source reports a real one; a
 * source that reports nothing, or only octet-stream (Nextcloud does for a docx), is judged by the file name,
 * the same way the API decides what it parks for the viewer.
 */
export const needsOfficeOnlineViewer = (mimeType: string | undefined, fileName?: string): boolean => {
  const normalized = mimeType?.trim().toLowerCase() ?? '';

  if (normalized && normalized !== 'application/octet-stream') {
    return (
      normalized.includes('ms-powerpoint') ||
      normalized.includes('ms-excel') ||
      normalized.includes('ms-word') ||
      normalized.includes('openxmlformats-officedocument')
    );
  }

  const name = fileName?.trim().toLowerCase() ?? '';

  return officeExtensions.some((extension) => name.endsWith(extension));
};

export const getOfficeOnlineViewerUrl = (fileUrl: string): string =>
  `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;
